import isEmpty from "lodash/isEmpty";
import { createSelector } from "@reduxjs/toolkit";

import { getDummyStoreDetails, getIsPricelessShop, getStore } from "@selectors/store";
import { createMenuCodeMapping } from "@helpers/menu";
import { MY_DESIGNED_SWAG_LOCKER } from "@constants/menu";

const defaultObj = {};

export const getMenu = ({ menu }) => menu;
export const getMenuId = ({ menu }) => menu?.id;
export const getMenuAllChildren = ({ menu }) => menu?.allChildren;
export const getMenuIsLoaded = ({ menu }) => menu?.isLoaded;

export const getIsMultiTierMenu = ({ menu }) => menu?.totalLevel > 2;

export const getMenuCodeMapping = createSelector(getMenu, (menu) => createMenuCodeMapping(menu));

const selectStoreDetails = createSelector(
  getDummyStoreDetails,
  getStore,
  (dummyStoreDetails, store) => {
    const storeDetails = isEmpty(dummyStoreDetails) ? store : dummyStoreDetails;
    return storeDetails;
  },
);

export const getPricelessShopMinPrice = createSelector(selectStoreDetails, (storeDetails) => {
  return storeDetails?.minPrice;
});

export const getPricelessShopMaxPrice = createSelector(selectStoreDetails, (storeDetails) => {
  return storeDetails?.maxPrice;
});

export const getPricelessMenuVariables = createSelector(
  getIsPricelessShop,
  getPricelessShopMinPrice,
  getPricelessShopMaxPrice,
  (isPricelessShop, minPrice, maxPrice) => {
    return isPricelessShop
      ? {
          forPriceless: true,
          minPrice: minPrice,
          maxPrice: maxPrice,
        }
      : defaultObj;
  },
);

export const getIsMyDesignedSwagPresent = createSelector(getMenu, (menu) => {
  return !!menu?.allChildren?.find((item) => item.code === MY_DESIGNED_SWAG_LOCKER);
});
